import { render } from "./ComingSoonView.vue?vue&type=template&id=70c2440c&scoped=true&ts=true"
import script from "./ComingSoonView.vue?vue&type=script&lang=ts"
export * from "./ComingSoonView.vue?vue&type=script&lang=ts"

import "./ComingSoonView.vue?vue&type=style&index=0&id=70c2440c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70c2440c"]])

export default __exports__